export default __webpack_public_path__ + "static/media/Hand.c948e01b.jpg";